import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MenuAction } from '../../modules/common-shared-module/core/model/menu/menu-action.model';
import { ConfigService } from '../../modules/common-shared-module/core/services/config/config.service';
import { MainMenuService } from '../../modules/common-shared-module/services/menu/main-menu.service';
import { SpinnerService } from '../../modules/common-shared-module/core/services/spinner/spinner.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    //encapsulation: ViewEncapsulation.None
})
export class HomeComponent implements OnInit, OnDestroy {

    configAvailable: boolean = false

    toggle = true;
    opSelected: { icon: string, name: string, path: string }
    loading = false;
    spinnerSubscription: Subscription
    menuSubscription: Subscription

    options: { icon: string, name: string, path: string }[] = [
        //    { icon: "home", name: "Inici", path: "/" },
        { icon: "home", name: "Inici", path: "/home/catproc/public-home" },
        { icon: "book", name: "Catàleg", path: "/home/catproc/public-catalog" },
        { icon: "file_copy", name: "Espai de tramitació", path: "/home/catproc/public-procedure" },
    ]

    constructor(private router: Router, private spinnerService: SpinnerService,
        private configService: ConfigService, private mainMenuService: MainMenuService) {

        this.opSelected = this.options[0] //this lines is mandatory to compile

        this.spinnerSubscription = this.spinnerService.subscribe((loading) => {
            this.loading = loading
        })

        this.menuSubscription = this.mainMenuService.subscribe((action: MenuAction) => {
            switch (action) {
                case MenuAction.close:
                    this.toggle = false
                    break;
                case MenuAction.open:
                    this.toggle = true
                    break;
                case MenuAction.toggle:
                    this.toggle = !this.toggle
                    break;
            }

        })

        this.configService.init().subscribe(config => {

            this.configAvailable = true

            //If no eacat tramits tr user, then remove the not needed users
            if (config.hasUserProfile() == false) {
                this.options.splice(1, this.options.length)
            }

            if (this.configService.config.hasSupportProfile()) {
                this.options.push({ icon: "support_agent", name: "CAU", path: "/home/catproc/public-support" },)
            }

            if (this.configService.config.hasAocManagerProfile()) {
                this.options.push({ icon: "hub", name: "Gestor AOC", path: "/aocadmin" },)
            }

            if (this.configService.config.hasBatchProfile()) {
                this.options.push({ icon: "auto_awesome_motion", name: "Tramesa massiva", path: "/home/catproc/public-batch" })
            }

            this.setSelectedOption(router);

            router.events.forEach((event) => {

                if (event instanceof NavigationEnd) {
                    this.setSelectedOption(router);
                }

                //console.log((<any>event).url)
                if (event instanceof NavigationEnd && (event.url == '/home/myaccount/my-account-home' || event.url == '/home/catproc/public-catalog/public-catalog-bookmarks' || event.url == '/bookmarks')) {
                    this.opSelected = { icon: "", name: '', path: '' }
                    this.toggle = false
                }

            });

        })

    }

    private setSelectedOption(router: Router) {
        this.options.forEach(Option => {
            if (router.url.startsWith(Option.path)) {
                this.selectOp(Option);
            }
        });
    }

    ngOnDestroy(): void {
        this.spinnerSubscription.unsubscribe()
        this.menuSubscription.unsubscribe()
    }

    ngOnInit(): void {

    }

    selectOp(option: { icon: string, name: string, path: string }) {
        if (option.path == "/") {
            this.toggle = true
        } else {
            this.toggle = false
        }
        this.opSelected = option
        //this.router.navigateByUrl(option.path)
    }

    doNavigation(option: { icon: string, name: string, path: string }) {
        this.router.navigateByUrl(option.path)
    }

    doToggle() {
        this.mainMenuService.click()
    }

}
